import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { TitleBar, IconCircle, IconClose, IconCheck, evenRowColor } from '../common/theme';

const StudentAssignmentTableComp = ({pageState}) => {    

    const titleRow = <TitleBar>
        <Col  style={{textAlign: 'left'}} xs='6'>Students</Col>
        <Col xs='2'>Pre-Test</Col>
        <Col xs='2'>Post-Test</Col>
        <Col xs='2'>Assigned Modules</Col>
    </TitleBar>;

    return ( 
        <Container>
            {titleRow}
            {pageState.processedStudentAssignments.map((studRec, i) => 
                <StudentRow key={i} index={i} studRec={studRec} componentState={{checkboxState:pageState.checkboxState, setCheckboxState:pageState.setCheckboxState}} pageState={pageState}/>
            )}
        </Container>
    ); 
};

StudentAssignmentTableComp.propTypes = {
    data: PropTypes.object
};

const CombinedIcon = ({type}) => <>
   {type === 'Mixed' && <IconCircle style={{color: 'green', fontSize: '10px' }}/>}
   {type === 'None' && <IconClose style={{color: '#EfEfEf'}} />}
    {type === 'All' && <IconCheck style={{color: 'green'}}/>}
</>;

const StudentRow = ({pageState, studRec, index}) => {
    let {StudentID, Name} = studRec;    
    
    const selectedStyle = () =>{
        let style = {cursor: 'pointer',color:'blue',textDecoration:'underline'};
        style['background'] = (index%2==0)?evenRowColor:'FFFFFF';
        return style;
    };

    const showModules = (programID) =>{
        pageState.setShowModulesComp(StudentID);
    };

    return (
        <>
        <Row onClick={() => showModules(StudentID)} style={selectedStyle()}> 
            <Col xs='6'> {Name}</Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={studRec.hasPretest}/> </Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={studRec.hasPosttest}/> </Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={studRec.hasAssignment}/></Col>
        </Row>
        </>
    );
};

export default StudentAssignmentTableComp;